module.exports = __webpack_public_path__ + "img/ad.e2990f5d.svg";